import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
            padding: 20px;
            font-size: ${theme.typography.h3.fontSize}px;
            line-height: ${theme.typography.h3.lineHeight};
            color: ${theme.palette.secondary[600]};
        `,
        button: css`
            ${custom.button};
            width: auto;
            margin-top: 20px;
            padding: 0 30px;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
        `,
    }
}

export default styles
